import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import GridLower from "./grid/gridLower";
import axios from "axios";
import MarkdownIt from "markdown-it";
import { renderers } from "./qna/rederers";
import MdEditor from "react-markdown-editor-lite";
import { useSelector } from "react-redux";

const mdParser = new MarkdownIt({
  html: true,
  renderers: renderers,
});

const DoubtSupport = () => {
  const { isLoggedIn } = useSelector((state) => state.verify).result;
  const getuser = useSelector((state) => state.getuser).result;
  const [loadingMentors, setLoadingMentors] = useState(false);
  const [mentors, setMentors] = useState([]);
  const [doubtDetails, setDoubtDetails] = useState("");
  const [selectedmentor, setSelectedMentor] = useState("");
  const [loadingaskdoubt, setLoadingAskDoubt] = useState(false);
  const handleFetchMentors = async () => {
    setLoadingMentors(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      const res = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/selectmentor`,
        { headers }
      );
      console.log(res);
      if (res.data) {
        setMentors(res.data);
      } else {
        alert("No Mentors Found");
        setMentors([]);
      }
    } catch (err) {
      console.log("Error fetching mentors", err);
    }
    setLoadingMentors(false);
  };
  const handleAskDoubt = async (e) => {
    e.preventDefault();
    if (selectedmentor == "" || doubtDetails == "") {
      alert("Empty Fields..");
      return;
    }
    setLoadingAskDoubt(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/Askdoubt`,
        {
          mentor: selectedmentor,
          student: getuser?.result?._id,
          doubt: doubtDetails,
        },
        { headers }
      );
      console.log(res);
      if (res.data) {
        alert(res?.data?.message);
      } else {
        alert("Error While Asking Doubt");
      }
    } catch (err) {
      console.log("Error fetching mentors", err);
    }
    setDoubtDetails("");
    setSelectedMentor("");
    setLoadingAskDoubt(false);
  };
  useEffect(() => {
    handleFetchMentors();
  }, []);
  const handleEditorChange = ({ text }) => {
    setDoubtDetails(text);
  };
  const handleImageUpload = async (file) => {
    try {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          const base64String = reader.result;
          resolve(base64String);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    } catch (error) {
      console.error("Error uploading image:", error);
      return null;
    }
  };
  return (
    <>
      <div className="container-home">
        <div className="home-left">
          <div className="text-5xl md:text-6xl font-bold mt-0">
            Prepare Your Kids For The Future with Experienced Teacher
          </div>
        </div>
        <div className="home-right">
          <img
            className="w-[50%] h-[50%] ml-40"
            src="/dizzy-happy-girl-in-graduation-gown-jumps-and-tosses-her-graduation-cap 1.png"
          />
        </div>
      </div>
      <div className="text-gray py-4 px-6 text-left container-home1">
        <div className="text-lg font-semibold mb-2">
          Kids who learn to code are ready to face their ever-changing future.
          Our Experienced teacher will help your kids develop the resilience,
          skills, and abilities to respond productively to those changes.
        </div>
      </div>
      {isLoggedIn && !getuser?.result?.isTeacher && (
        <div>
          <div className="mt-0 z-0">
            <GridLower />
          </div>
          {/* </section> */}
          <h1 className="mb-6 mt-4 text-5xl font-extrabold tracking-tight text-center text-black-900 lg:mb-8 lg:text-5xl">
            CONNECT WITH OUR MENTORS
          </h1>
          <section className="container mx-auto p-2">
            <div className="mb-4">
              <h2 className="text-3xl font-semibold mb-2">Submit a Doubt</h2>
              <form noValidate onSubmit={handleAskDoubt}>
                <div className="flex flex-col mb-2">
                  <label for="mentor" className="text-sm mb-1">
                    Select a Mentor
                  </label>
                  <select
                    id="mentor"
                    value={selectedmentor}
                    onChange={(e) => setSelectedMentor(e.target.value)}
                    className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {loadingMentors && (
                      <option value="">Loading Mentors..</option>
                    )}
                    <option value="">-- Select a Mentor --</option>
                    {!loadingMentors &&
                      mentors?.map((mentor, index) => {
                        return (
                          <option value={mentor?._id} key={index}>
                            {mentor?.name}-{mentor?.email}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="flex flex-col mb-2">
                  <label for="doubt" className="text-sm mb-1">
                    Your Doubt
                  </label>
                  <MdEditor
                    id="details"
                    placeholder="e.g. I didn't understand this part,here is the attached screenshot..."
                    value={doubtDetails}
                    style={{ height: "400px" }}
                    renderHTML={(text) => {
                      const modifiedText = text;
                      return mdParser.render(modifiedText);
                    }}
                    onChange={handleEditorChange}
                    onImageUpload={handleImageUpload}
                    view={{
                      markdown: true,
                      html: false,
                      fullScreen: false,
                      hideMenu: false,
                    }}
                    config={{
                      view: {
                        menu: true,
                        md: true,
                        html: false,
                      },
                      canView: {
                        menu: true,
                        md: true,
                        html: true,
                        fullScreen: true,
                        hideMenu: true,
                      },
                      markdownClass: "markdown-body",
                    }}
                  />
                </div>
                <button
                  type="submit"
                  disabled={loadingaskdoubt}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {loadingaskdoubt ? "Please Wait.." : "Submit"}
                </button>
              </form>
            </div>
          </section>
          <h1 className="mb-6 mt-4 text-5xl font-extrabold tracking-tight text-center text-black-900 lg:mb-8 lg:text-5xl">
            Still have Doubt?
          </h1>
          <div className="flex justify-start flex-wrap gap-4 p-5">
            {!loadingMentors &&
              mentors?.map((mentor, index) => {
                return (
                  <div
                    className="bg-white shadow-md rounded-lg p-4"
                    key={index}
                  >
                    <img
                      src={require("./gmeet.jpg")}
                      style={{ height: "100px", width: "auto" }}
                      alt="..."
                    />

                    <h3 className="text-xl text-left font-semibold mb-2 mt-3">
                      {mentor?.name}
                    </h3>
                    <p className="mb-2">Email: {mentor?.email}</p>
                    <p className="mb-4">Id: {mentor?._id}</p>
                    <a
                      href="#"
                      target="_blank"
                      className="px-4 py-2  bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      Schedule a Meeting
                    </a>
                  </div>
                );
              })}
          </div>
          <div className="mt-4 z-0">
            <GridLower />
          </div>
          <div className="mt-2">
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default DoubtSupport;